import React, { useRef, useState, useEffect } from 'react';
import { Select, Space, Button } from 'antd';
import WebRTCAdaptor from './WebRTCAdapter';
const { Option } = Select;
// import freeice from "freeice";

// const TURN_SERVER = "https://dev.runfullstack.co:8080/";
// const STUN_SERVER = freeice();

// const webrtc = new RTCPeerConnection({
//   iceServers: [
//     {
//       urls: ["stun:stun.stunprotocol.org"],
//     },
//   ],
// });

// const webSocket = new WebSocket("wss://ant.rptr.live:5080/WebRTCApp/websocket");
const pc_config = null;

const sdpConstraints = {
  OfferToReceiveAudio: false,
  OfferToReceiveVideo: false,
};
const mediaConstraints = {
  video: true,
  audio: true,
};

// @ts-ignore
// window.ws = webSocket;
// // @ts-ignore
// window.webrtc = webrtc;
// // @ts-ignore
// window.test1 = async function () {
//   await webSocket.send(
//     JSON.stringify({
//       command: "publish",
//       streamId: "stream1",
//       // token: "tokenId",
//     })
//   );
// };

// // @ts-ignore
// window.test2 = async function () {
//   const offer = await webrtc.createOffer();
//   console.log(offer);
//   await webrtc.setLocalDescription(offer);
//   await webSocket.send(
//     JSON.stringify({
//       command: "takeConfiguration",
//       streamId: "stream1",
//       type: "offer",
//       sdp: offer.sdp,
//     })
//   );
// };

// // // @ts-ignore
// // window.test3 = async function () {
// //   const { sdp } = await webrtc.createOffer();
// //   await webSocket.send(
// //     JSON.stringify({
// //       command: "takeConfiguration",
// //       streamId: "stream1",
// //       type: "offer",
// //       sdp,
// //     })
// //   );
// // };

// function sendMessageToSignallingServer(message) {
//   const json = JSON.stringify(message);
//   webSocket.send(json);
// }

// webSocket.addEventListener("open", () => {
//   // sendMessageToSignallingServer({
//   //   channel: "login",
//   //   name: username,
//   // });
// });

// webSocket.addEventListener("message", (event) => {
//   const message = JSON.parse(event.data.toString());
//   console.log(message);
//   // handleMessage(message);
// });

// let otherPerson;

// async function handleMessage(message) {
//   console.log(message.type);
//   switch (message.type) {
//     case "start_call":
//       // done by Bob: create a webrtc offer for Alice
//       otherPerson = message.otherPerson;
//       console.log(`receiving call from ${otherPerson}`);

//       const offer = await webrtc.createOffer();
//       await webrtc.setLocalDescription(offer);
//       sendMessageToSignallingServer({
//         channel: "webrtc_offer",
//         offer,
//         otherPerson,
//       });
//       break;

//     case "takeConfiguration":
//       // done by Alice: react to Bob's webrtc offer
//       console.log("received webrtc offer");
//       // we might want to create a new RTCSessionDescription
//       // from the incoming offer, but as JavaScript doesn't
//       // care about types anyway, this works just fine:
//       await webrtc.setRemoteDescription(message.offer);

//       const answer = await webrtc.createAnswer();
//       await webrtc.setLocalDescription(answer);

//       sendMessageToSignallingServer({
//         channel: "webrtc_answer",
//         answer,
//         otherPerson,
//       });
//       break;

//     case "answer":
//       // done by Bob: use Alice's webrtc answer
//       console.log("received webrtc answer");
//       await webrtc.setRemoteDescription(message.answer);
//       break;

//     case "webrtc_ice_candidate":
//       // done by both Alice and Bob: add the other one's
//       // ice candidates
//       console.log("received ice candidate");
//       // we could also "revive" this as a new RTCIceCandidate
//       await webrtc.addIceCandidate(message.candidate);
//       break;

//     default:
//       console.log("unknown message", message);
//       break;
//   }
// }

export default function Connect() {
  return (
    <div className='App'>
      <Camera />
      {/* <WebRTCClient
        video={true}
        autoRegister={true}
        autoConnect={true}
        // sipDomain={sipDomain}
        // sipServer={sipServer}
        // sipUser={sipUser}
        // sipPassword={sipPassword}
        destination={"wss://ant.rptr.live:5080/WebRTCApp/websocket"}
        // metaData={metaDataObject}
        alertVideoUrl="alertUrl"
        ringbackVideoUrl="ringbackUrl"
        hideConnectionStatus={false}
        traceSip={false}
        callLabel="Custom call label"
        remoteVideo="remoteVideoElementId"
        localVideo="localVideoElementId"
        // jwtAuth="JWTAuthToken"
      /> */}
    </div>
  );
}

const CAPTURE_OPTIONS = {
  audio: false,
  video: { facingMode: 'environment' },
};

function Camera() {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const mediaStream = useUserMedia(CAPTURE_OPTIONS);
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
  const [videoStream, setVideoStream] = useState<number | string | null>(null);
  const [audioStream, setAudioStream] = useState<number | string | null>(null);
  const [webRTCAdaptor, setWebRTCAdaptor] = useState<WebRTCAdaptor | null>(null);

  useEffect(() => {
    const newWebRTCAdaptor = new WebRTCAdaptor({
      websocket_url: 'wss://ant.rptr.live:5443/LiveApp/websocket',
      mediaConstraints: mediaConstraints,
      peerconnection_config: pc_config,
      sdp_constraints: sdpConstraints,
      localVideoId: 'localVideo',
      callback: function (info: string) {
        if (info === 'initialized') {
          console.log('initialized');
        } else if (info === 'publish_started') {
          //stream is being published
          console.log('publish started');
        } else if (info === 'publish_finished') {
          //stream is finished
          console.log('publish finished');
        } else if (info === 'screen_share_extension_available') {
          //screen share extension is avaiable
          console.log('screen share extension available');
        } else if (info === 'screen_share_stopped') {
          //"Stop Sharing" is clicked in chrome screen share dialog
          console.log('screen share stopped');
        }
      },
      callbackError: function (error: Error, message: string) {
        //some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError
        console.log(error, message);
      },
    });
    setWebRTCAdaptor(newWebRTCAdaptor);

    return () => {
      if (webRTCAdaptor && webRTCAdaptor.stop) {
        webRTCAdaptor.stop('test');
      }
    };
  }, [webRTCAdaptor]);

  useEffect(() => {
    async function exec() {
      const devices = await navigator.mediaDevices.enumerateDevices();
      setDevices(devices);
    }
    exec();
  }, []);

  useEffect(() => {
    async function exec() {
      const initialAudioDevice = devices.filter((device) => device.kind === 'audioinput')[0];

      if (initialAudioDevice) {
        setAudioStream(initialAudioDevice.deviceId);
      }

      const initialVideoDevice = devices.filter((device) => device.kind === 'videoinput')[0];

      if (initialVideoDevice) {
        setVideoStream(initialVideoDevice.deviceId);
      }
    }
    exec();
  }, [devices]);

  useEffect(() => {
    async function exec() {
      if (mediaStream && videoRef && videoRef.current) {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            deviceId: String(videoStream),
          },
        });
        videoRef.current.srcObject = stream;
        // for (const track of stream.getTracks()) {
        //   // webrtc.addTrack(track, stream);
        // }
      }
    }
    console.log('called');
    exec();
  }, [videoStream, mediaStream]);

  function handleCanPlay() {
    videoRef.current?.play();
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', padding: '1em' }}>
        <Space>
          <Select
            style={{ width: 400 }}
            placeholder='Select video input'
            onSelect={(value) => {
              setVideoStream(String(value));
            }}
            value={String(videoStream)}>
            {devices
              .filter((device) => device.kind === 'videoinput')
              .map((device) => (
                <Option key={device.deviceId} value={device.deviceId}>
                  {device.label}
                </Option>
              ))}
          </Select>
          <Select
            style={{ width: 400 }}
            placeholder='Select audio input'
            onSelect={(value) => {
              setAudioStream(String(value));
            }}
            value={audioStream || undefined}>
            {devices
              .filter((device) => device.kind === 'audioinput')
              .map((device) => (
                <Option key={device.deviceId} value={device.deviceId}>
                  {device.label}
                </Option>
              ))}
          </Select>
          <Button
            onClick={() => {
              if (webRTCAdaptor?.publish) {
                webRTCAdaptor.publish('test', null);
              }
            }}>
            Start
          </Button>
        </Space>
      </div>
      <div>
        <video
          id='localVideo'
          ref={videoRef}
          onCanPlay={handleCanPlay}
          autoPlay
          playsInline
          muted
        />
      </div>
    </div>
  );
}

function useUserMedia(requestedMedia: MediaStreamConstraints) {
  const [mediaStream, setMediaStream] = useState<MediaStream | null>(null);

  useEffect(() => {
    async function enableStream() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia(requestedMedia);
        setMediaStream(stream);
      } catch (err) {
        // Removed for brevity
      }
    }

    if (!mediaStream) {
      enableStream();
    } else {
      return function cleanup() {
        mediaStream.getTracks().forEach((track) => {
          track.stop();
        });
      };
    }
  }, [mediaStream, requestedMedia]);

  return mediaStream;
}
